import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Messages } from "primereact/messages";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";
import _css from "./login.module.css";
import "./login.css";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";

interface IFormInputs {
  login_Name: string;
  login_Password: string;
}

const schema = yup.object({
  login_Name: yup.string().required("username is required*"),
  login_Password: yup.string().required("password is required*"),
});

export const Login = () => {
  const message = useRef<any>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setFocus,
  } = useForm<IFormInputs>({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (!loading) {
      const form = document.querySelector("form");
      form?.classList.add("invalid_details");
      setTimeout(() => {
        form?.classList.remove("invalid_details");
      }, 550);
    }
  }, [loading]);

  useEffect(() => {
    setFocus("login_Name");
  }, [setFocus]);

  async function onSubmitLogin(data: IFormInputs) {
    setLoading(true);
    const response = await Fetch(
      "External_User_Mast/login",
      "POST",
      { ...data, User_Name: "", User_EmailID: "" },
      null,
      message
    );
    if (response) {
      const data: ILogin = await response.json();
      sessionStorage.setItem("auth", JSON.stringify(data));
      if (data.id === 1) {
        sessionStorage.setItem(
          "adminAuth",
          JSON.stringify({
            isAdminAuth: true,
          })
        );
      }
      if (data?.firstLogin === true) {
        if (data?.email) {
          const response = await fetch(
            baseUrl + "External_User_Mast/forgotpassword?first=1",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email: data?.email }),
            }
          );
          if (response.ok) {
            sessionStorage.setItem("resetEmail", data.email);
            sessionStorage.setItem("step", "otp");
          }
        }

        navigate("/resetpassword");
      } else {
        navigate("/");
      }
    } else {
      setLoading(false);
    }
  }

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };
  const handleResetPassword = () => {
    navigate("/reset-password");
  };

  return (
    <div className="login-body">
      <div className="login-wrapper">
        <div className="login-panel">
          <img src="img/logo.png" width={256} alt="jobvritta" />
          <form onSubmit={handleSubmit(onSubmitLogin)} className="col-12">
            <div className="card">
              <h5>Login</h5>
              <Messages ref={message} />
              <div className="grid p-fluid">
                <div className="col-12 md:col-12">
                  <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                      <i className="pi pi-user"></i>
                    </span>
                    <Controller
                      name="login_Name"
                      control={control}
                      defaultValue={""}
                      render={({ field, fieldState }) => (
                        <InputText
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          placeholder="UserName"
                        />
                      )}
                    />
                  </div>
                </div>
                <small
                  className="p-error"
                  style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}
                >
                  {errors.login_Name?.message}
                </small>
                <div className="col-12 md:col-12">
                  <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">
                      <i className="pi pi-lock"></i>
                    </span>
                    <Controller
                      name="login_Password"
                      control={control}
                      defaultValue={""}
                      render={({ field, fieldState }) => (
                        <InputText
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          type="password"
                          placeholder="Password"
                        />
                      )}
                    />
                  </div>
                </div>
                <small
                  className="p-error"
                  style={{ marginLeft: "3.5rem", marginTop: "-1rem" }}
                >
                  {errors.login_Password?.message}
                </small>
                <div className="col-12 md:col-12">
                  <Button
                    label="LOGIN"
                    type="submit"
                    loading={loading}
                  ></Button>
                </div>
                {/* Forgot Password button */}
                <div className="col-12 md:col-12 mt-3">
                  <div className="flex justify-content-between">
                    <Button
                      label="Forgot Password?"
                      className="p-button-text"
                      onClick={handleForgotPassword}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <p></p>
        </div>
        <div className="login-image">
          <div className={`login-image-content ${_css.container}`}>
            <h1>Access to your</h1>
            <h1>JobVritta</h1>
            <h1>Account</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
